import {
  ErrorModal,
  MesfModal,
  TimeService,
  getMomentTz,
} from "@dexteel/mesf-core";
import { Grid } from "@mui/material";
import { DateTimePicker } from "@mui/x-date-pickers";
import { useEffect, useState } from "react";
import { FooterModalButtons } from "../../../../controls/buttons/FooterModalButtons";
import { NotificationSnackBar } from "../../../../controls/snackbars/notification-snackbar";
import {
  upsertLadleRelining,
  upsertPlugChange,
} from "../repositories/LadleMaintenanceRepository";

const moment = getMomentTz();

type Props = {
  showModal: "PLUG" | "RELINING" | "";
  data: { id: number | null; ladleId: number; timestamp: Date | null };
  onHide: () => void;
  title: string;
};

export const DatePickerModal = ({
  showModal,
  data,
  onHide,
  title,
}: Props): JSX.Element => {
  const [dateSelected, setDateSelected] = useState<Date | null>(data.timestamp);
  const [notificationMessage, setNotificationMessage] = useState("");
  const [isSubmitLoading, setIsSubmitLoading] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    setDateSelected(data.timestamp);
  }, [data.timestamp, showModal]);

  const saveData = async (): Promise<void> => {
    setIsSubmitLoading(true);
    if (showModal === "PLUG") {
      const resp = await upsertPlugChange({
        ladleId: data.ladleId,
        plugChangeId: data.id,
        timestamp: dateSelected,
      });
      if (resp.ok) {
        onHide();
      } else {
        setError(resp.message);
      }
    } else if (showModal === "RELINING") {
      const resp = await upsertLadleRelining({
        ladleId: data.ladleId,
        ladleReliningId: data.id,
        timestamp: dateSelected,
      });
      if (resp.ok) {
        onHide();
      } else {
        setError(resp.message);
      }
    }
    setIsSubmitLoading(false);
  };

  return (
    <>
      <MesfModal
        title={title}
        open={showModal != ""}
        handleClose={(): void => onHide()}
        id="bin-modal"
        maxWidth="lg"
      >
        <form
          onSubmit={(e): void => {
            e.preventDefault();
            saveData();
          }}
        >
          <MesfModal.Content dividers style={{ padding: "15px 30px" }}>
            <Grid
              item
              xs={12}
              md={12}
              style={{
                display: "flex",
                justifyContent: "center",
              }}
            >
              <DateTimePicker
                timezone={TimeService.getInstance().getServerTimeZone()}
                label="From"
                format="MM/DD/YYYY HH:mm"
                value={dateSelected ? moment(dateSelected) : null}
                onChange={(newValue): void => {
                  setDateSelected(newValue?.toDate() ?? null);
                }}
                ampm={false}
                sx={{ width: "80%" }}
                slotProps={{
                  textField: {
                    variant: "outlined",
                    fullWidth: true,
                  },
                }}
              />
            </Grid>
          </MesfModal.Content>
          <MesfModal.Actions style={{ padding: "20px 30px 30px" }}>
            <FooterModalButtons
              isSubmitLoading={isSubmitLoading}
              onHide={(): void => onHide()}
            />
          </MesfModal.Actions>
        </form>
      </MesfModal>
      <NotificationSnackBar
        message={notificationMessage}
        onHide={(): void => setNotificationMessage("")}
      />
      <ErrorModal
        error={error}
        onHide={(): void => setError("")}
        title="Error with Ladle"
      />
    </>
  );
};
